<template>
  <div v-if="shouldRender" class="related-items">
    <h4>{{ getContentItem("relatedOrders") }}</h4>
    <br>
    <ul>
      <li v-for="(item, index) in relatedOrders" :key="index">
        <related-order-link :item="item" />
        <span v-if="shouldRenderPlacedBy(item)">
          placed by
          <a :href="`mailto:${item.OrderedByEmail}`">{{ item.OrderedByName }}</a>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import RelatedOrderLink from "@/components/Invoices/RelatedOrderLink"

  export default {
    name: "RelatedOrders",
    components: {
      RelatedOrderLink
    },
    computed: {
      ...mapGetters(["getContentItem"]),
      shouldRender() {
        return this.relatedOrders && this.relatedOrders.length > 0;
      }
    },
    props: {
      relatedOrders: Array
    },
    methods: {
      shouldRenderPlacedBy: item => {
        return item.OrderedByName && item.OrderedByName !== "Unknown";
      }
    }
  };
</script>
